import { AppBarClearance, Breakpoints } from './responsive';

const scifiColor = '#84ffff';

export const AppBarPadding = {
  paddingTop: AppBarClearance.Base,
  [Breakpoints.Landscape]: {
    paddingTop: AppBarClearance.Landscape,
  },
  [Breakpoints.Tablet]: {
    paddingTop: AppBarClearance.Tablet,
  },
};

export const blueBorderValue = `1px solid ${scifiColor}`;

export const invertedText = {
  color: '#ffffff',
};

export const LinkCustom = {
  textDecoration: 'none',
};

export const scifiBackground = {
  backgroundColor: '#84ffff',
};

export const scifiButton = {
  textDecoraction: 'underline',
  textDecorationColor: scifiColor,
};

export const scifiText = {
  color: scifiColor,
};



// WEBPACK FOOTER //
// ./src/utils/styles.ts